import React from 'react';
import ToursContainer from '../../Componant/Bonus-Ui/Tour';

const Tours = () => {
  return (
    <div className='page-body'>
      <ToursContainer />
    </div>
  );
};

export default Tours;
